import React from 'react';

import * as ResourceApi from 'api/resources';
import IndexedSubSectionWrapper from "hoc/IndexedSubSectionWrapper";
import {createButtonSectionFactory,createButtonSectionFactoryWithAdditionalArgs} from "hoc/CreateButtonSection";
import {FBCommentQuestionToolTip} from 'components/break/tooltips/breaks-steps-section-tool-tips';

import {FormattedMessage, IntlProvider} from 'react-intl';
import {enUSmessage} from 'i18n/en-US.js';
import {
  PersonalityQuizAnswerButtonBackgroundColorToolTip,
  PersonalityQuizAnswerButtonBorderColorToolTip,
  PersonalityQuizAnswerButtonTextColorToolTip,
  PersonalityQuizAnswerEditButtonColorsToolTip,
  PersonalityQuizAnswerImageToolTip,
  PersonalityQuizAnswerToolTip,
  PersonalityQuizAnswerTypeToolTip,
  PersonalityQuizConnectedResultToolTip,
  PersonalityQuizDefaultAnswerButtonBackgroundColorToolTip,
  PersonalityQuizHeadlineToolTip,
  PersonalityQuizIntroCopyToolTip,
  PersonalityQuizListResultHeadlineToolTip,
  PersonalityQuizQuestionImageToolTip,
  PersonalityQuizQuestionShowOverlayToolTip,
  PersonalityQuizQuestionToolTip,
  PersonalityQuizQuestionTypeToolTip,
  PersonalityQuizResultDescriptionToolTip,
  PersonalityQuizResultImageToolTip,
  PersonalityQuizResultSocialShareImageToolTip,
  PersonalityQuizResultTitleToolTip,
  PersonalityQuizResultTypeToolTip,
  PersonalityQuizResultURLTextToolTip,
  PersonalityQuizResultURLToolTip
} from 'components/break/tooltips/personality-quiz-tool-tips';
import {isNoU, hasAllUserTagPermissions} from "utils/DBUtils";
import { isNewLayout} from 'utils/break-utils';


export default {
  name: "personalityQuiz",
  subSection: true,
  resource: true,
  hideIfResourceIsNoU: true,

  fields: [
    {
      type: 'hardcodedText',
      props: {
        headingKey: 'editbreak.steps.personality_quiz.suggestion_header',
        textKey: 'editbreak.steps.personality_quiz.suggestion_text'
      }
    },
    {
      type: 'contenteditable',
      name: 'headline',
      required: true,
      // Headline is only allowed if there is more than one Poll step
      showField: (proxy) => (proxy.currentBaseResource.steps && proxy.currentBaseResource.steps.length > 1),
      linkedField: (proxy) => ["title"],
      props: {
        labelKey: 'editbreak.steps.personality_quiz.headline',
        helpContent: <PersonalityQuizHeadlineToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'editbreak.steps.personality_quiz.headline'}/></IntlProvider>
      }
    },
    {
      type: 'contenteditable',
      name: 'introCopy',
      required: false,
      props: {
        labelKey: 'editbreak.steps.personality_quiz.intro_copy',
        maxLength: 500,
        placeholderKey: 'editbreak.steps.personality_quiz.intro_copy.placeholder',
        helpContent: <PersonalityQuizIntroCopyToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'editbreak.steps.personality_quiz.intro_copy'}/></IntlProvider>,
        validationRules: [
          {
            type: 'MarkupTextLimit',
            params: {
              limit: 500
            }
          }
        ]

      }
    },
    {
      type: 'text',
      name: 'commentQuestion',
      showField: (proxy) => (proxy.currentBaseResource.showFBComments && proxy.currentBaseResource.sponsoredType !== 'sponsored'),
      props: {
        labelKey: 'editbreak.steps.related_breaks.commentQuestion',
        helpContent: <FBCommentQuestionToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'tooltips.break.breaks_steps.fbCommentQuestion'}/></IntlProvider>
      }
    },
    {
      type: 'color',
      name: 'defaultAnswerBgColor',
      required: true,
      showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored'),
      linkedField: (formProxy) => ["missionColor1"],
      props: {
        labelKey: 'editbreak.steps.personality_quiz.answer_button_bg_color',
        helpContent: <PersonalityQuizDefaultAnswerButtonBackgroundColorToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'editbreak.steps.personality_quiz.answer_button_bg_color'}/></IntlProvider>
      }
    },
    {
      type: 'color',
      name: 'defaultAnswerTextColor',
      required: true,
      showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored'),
      linkedField: (formProxy) => ["missionColor6"],
      props: {
        labelKey: 'editbreak.steps.personality_quiz.answer_button_text_color',
        helpContent: <PersonalityQuizAnswerButtonTextColorToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'editbreak.steps.personality_quiz.answer_button_text_color'}/></IntlProvider>
      }
    },
    {
      type: 'color',
      name: 'defaultAnswerBorderColor',
      required: false,
      showField: (proxy) => (proxy.currentBaseResource.sponsoredType === 'sponsored'),
      props: {
        labelKey: 'editbreak.steps.personality_quiz.answer_button_border_color',
        helpContent: <PersonalityQuizAnswerButtonBorderColorToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'editbreak.steps.personality_quiz.answer_button_border_color'}/></IntlProvider>
      }
    },

      {
        type: 'color',
        name: 'questionBackgroundColor',
        // showField: (proxy) => {
        //     console.log(proxy)
        //     return (proxy.currentResource.sponsoredType === 'sponsored' && isNewLayout(proxy.currentResource))
        // },
        props: {
            labelKey: 'editbreak.steps.personality_quiz.questionBackgroundColor',
        }
      },

      {
        type: 'image',
        name: 'questionBackgroundImageId',
        idFor: 'questionBackgroundImage',
        // showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored' ),
        props: {
            labelKey: 'editbreak.steps.personality_quiz.questionBackgroundImage',
            imageType: 'stepBackgroundImage'
        }
      },

    {
      type: 'radio',
      name: 'resultDisplay',
      required: true,
      supportedPlatforms: [
        'MASTER'
      ],
      showField: (proxy) => (isNoU(proxy.currentBaseResource.hubId)),
      props: {
        labelKey: 'editbreak.steps.personality_quiz.result_type',
        helpContent: <PersonalityQuizResultTypeToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'editbreak.steps.personality_quiz.result_type'}/></IntlProvider>,
        colCount: 3,
        options: [
          {
            value: "MOST_CHOSEN",
            textKey: 'editbreak.steps.personality_quiz.result_type.most_chosen'
          },
        //   {
        //     value: "LIST_CHOSEN",
        //     textKey: 'editbreak.steps.personality_quiz.result_type.list_chosen'
        //   },
          {
            value: 'DECISION_TREE',
            textKey: 'editbreak.steps.personality_quiz.result_type.decision_tree'
          }
        ]
      }
    },
    {
      type: 'contenteditable',
      name: 'resultPrintTopText',
      required: true,
      showField: (proxy) => (proxy.currentResource.resultDisplay === 'LIST_CHOSEN'),
      props: {
        labelKey: 'editbreak.steps.personality_quiz.result_type.list_chosen.headline',
        placeholderKey: 'editbreak.steps.personality_quiz.result_type.list_chosen.headline.placeholder',
        helpContent: <PersonalityQuizListResultHeadlineToolTip/>,
        helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
          id={'editbreak.steps.personality_quiz.result_type.list_chosen.headline'}/></IntlProvider>,
      }
    },
    {
      type: 'contenteditable',
      name: 'resultTopText',
      required: false,
      showField: (proxy) => (proxy.currentResource.resultDisplay === 'LIST_CHOSEN'),
      props: {
        labelKey: 'editbreak.steps.personality_quiz.result_type.list_chosen.description',
        placeholderKey: 'editbreak.steps.personality_quiz.result_type.list_chosen.description.placeholder'
      }
    },
    {
      name: 'results',
      subSection: true,
      resource: true,
      collection: true,
      sectionWrapper: IndexedSubSectionWrapper,
      deletable: true,
      canDelete: (formProxy) => {
        var parentQuestion = formProxy.parentCurrentResource;
        return parentQuestion.results && parentQuestion.results.length > 1;
      },

      sortable: true,
      sortableName: "personalityQuizResultsOrder",
      toggleSortLabelKey: 'editbreak.steps.personality_quiz.result.reorder_toggle',
      resourceType: ResourceApi.Types.PersonalityQuizResult,

      props: {
        headerKey: 'editbreak.steps.personality_quiz.result.header',
        getCustomSectionHeader: (result, sectionIndex) => {
          return result.title
          && result.title.trim() !== "" ? "Result " + (sectionIndex + 1) + ": " + result.title : null;
        }
      },

      footerContent: createButtonSectionFactory(ResourceApi.Types.PersonalityQuizResult),

      fields: [
        {
          type: 'contenteditable',
          name: 'title',
          required: true,
          props: {
            labelKey: 'editbreak.steps.personality_quiz.result.title',
            placeholderKey: 'editbreak.steps.personality_quiz.result.title.placeholder',
            helpContent: <PersonalityQuizResultTitleToolTip/>,
            helpHeader: 'editbreak.steps.personality_quiz.result.title'
          }
        },
        {
          type: 'contenteditable',
          name: 'topText',
          required: false,
          props: {
            labelKey: 'editbreak.steps.personality_quiz.result.description',
            placeholderKey: 'editbreak.steps.personality_quiz.result.description.placeholder',
            helpContent: <PersonalityQuizResultDescriptionToolTip/>,
            helpHeader: 'editbreak.steps.personality_quiz.result.description'
          }
        },
        // we include imageId twice, one for old layout and one for new layout
        // first, old layout (imageType: 'personalityResult')
        {
          type: 'image',
          name: 'imageId',
          idFor: 'image',
          required: true,
          showField: (proxy) => {
            // console.log(proxy)
            return !(proxy.currentResource.resultLayout === "ONE_COLUMN_2024" || proxy.currentResource.resultLayout === "TWO_COLUMN_2024")
          },
          props: {
            labelKey: 'editbreak.steps.personality_quiz.result.image',
            imageType: 'personalityResult',
            helpContent: <PersonalityQuizResultImageToolTip/>,
            helpHeader: 'editbreak.steps.personality_quiz.result.image'
          }
        },
        // for new layout don't specify dimensions (imageType)
        {
            type: 'image',
            name: 'imageId',
            idFor: 'image',
            required: true,
            showField: (proxy) => {
            //   console.log(proxy)
              return (proxy.currentResource.resultLayout === "ONE_COLUMN_2024" || proxy.currentResource.resultLayout === "TWO_COLUMN_2024")
            },
            props: {
              labelKey: 'editbreak.steps.personality_quiz.result.image',
              imageType: 'custom',
            }
          },
  

        {
            type: 'text',
            name: 'videoId',
            required: false,
            props: {
              labelKey: 'editbreak.steps.personality_quiz.result.videoId',
            }
        },
        {
          conditionalSection: true,
          name: "hasShareImage",
          required: true,

          props: {
            labelKey: 'editbreak.steps.personality_quiz.result.has_share_image',
            helpContent: <PersonalityQuizResultSocialShareImageToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
              id={'editbreak.steps.personality_quiz.result.share_image'}/></IntlProvider>,
          },

          fields: [
            {
              type: 'image',
              name: 'shareImageId',
              idFor: 'shareImage',
              required: true,
              props: {
                labelKey: 'editbreak.steps.personality_quiz.result.share_image',
                imageType: 'socialShare'
              }
            }
          ]
        },
        {
          type: 'text',
          name: 'link',
          required: false,
          props: {
            labelKey: 'editbreak.steps.personality_quiz.result.link_url',
            helpContent: <PersonalityQuizResultURLToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
              id={'editbreak.steps.personality_quiz.result.link_url'}/></IntlProvider>,
          }
        },
        {
          type: 'text',
          name: 'linkTitle',
          required: false,
          props: {
            labelKey: 'editbreak.steps.personality_quiz.result.link_text',
            helpContent: <PersonalityQuizResultURLTextToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
              id={'editbreak.steps.personality_quiz.result.link_text'}/></IntlProvider>,
          }
        },
        {
            type: 'color',
            name: 'backgroundColor',
            // showField: (proxy) => {
            //     console.log(proxy)
            //     return (proxy.currentResource.sponsoredType === 'sponsored' && isNewLayout(proxy.currentResource))
            // },
            props: {
                labelKey: 'editbreak.steps.personality_quiz.result.backgroundColor',
            }
          },

          {
            type: 'image',
            name: 'backgroundImageId',
            idFor: 'backgroundImage',
            // showField: (proxy) => (proxy.currentResource.sponsoredType === 'sponsored' && isNewLayout(proxy.currentResource)),
            props: {
                labelKey: 'editbreak.steps.personality_quiz.result.backgroundImage',
              imageType: 'stepBackgroundImage'
            }
          },

          {
            type: 'radio',
            name: 'resultLayout',
            required: true,
            showField: true,
            props: {
              labelKey: 'editbreak.steps.personality_quiz.result.layout',
              colCount: 1,
              options: [
                {
                    value: "ONE_COLUMN_2024",
                    text: '1 Column'
                  },
                  {
                    value: "TWO_COLUMN_2024",
                    text: '2 Column'
                  },
                  {
                  value: "ONE_COLUMN",
                  text: '1 Column (legacy)'
                },
                {
                  value: "TWO_COLUMN",
                  text: '2 Column (legacy)'
                },
              ]
            }
        },

        {
          subSection: true,
          // key: "editbreak.steps.grocery.resultLink.header",
          sectionWrapper: IndexedSubSectionWrapper,
          props: {
            'headerKey': 'Dropdown Buttons',
          },
          fields: [
    
            {
              name: "dropdownButtons",
              subSection: true,
              resource: true,
              collection: true,
              sectionWrapper: IndexedSubSectionWrapper,
              deletable: true,
              canDelete: (formProxy) => {
                // logic like this would force at least one item
                //   var parentReview = formProxy.parentCurrentResource;
                //   return parentReview.products && parentReview.products.length > 1;
                    return true
              },
              sortable: true,
              sortableName: "linksOrder",
              resourceType: ResourceApi.Types.DropdownButton,
              toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
              props: {
                headerKey: 'Button Links',
                getCustomSectionHeader: (item, sectionIndex) => {
                  // console.log("custom header", item)
                  if (!item.links) {
                    item.links = []
                  }
    
                  let links = item.links.filter((item) => { 
                    return item.deleted === false
                  })
                  if (links.length > 1) {
                    return item.buttonCopy ? item.buttonCopy : `dropdownbutton - ${ (sectionIndex + 1) }`
                  } else if (links.length === 1) {
                    return links[0].label
                  } else {
                    return `dropdownbutton - ${ (sectionIndex + 1) }`
                  }
                }
              },
          
    
              footerContent: createButtonSectionFactory(ResourceApi.Types.DropdownButton),
    
              fields: [
                      {
                        type: 'hardcodedText',
                        key: "links-helper",
                        props: {
                          text: 'If you include a single link, the UI will show a button. Incude multiple links and the UI will show a dropdown button.',
                        }
                      },
                      {
                        type: "contenteditable",
                        name: "label",
                        required: false,
                        props: {
                          labelKey: "Button Copy",
                        },
                        showField: (proxy) => {
                          
                          let links = proxy.currentResource.links.filter((item) => { 
                            return item.deleted === false
                          })
    
                          return (links.length > 1)
                        },
                      },
                      {
                        name: "links",
                        subSection: true,
                        resource: true,
                        collection: true,
                        sectionWrapper: IndexedSubSectionWrapper,
                        deletable: true,
                        canDelete: (formProxy) => {
                          // logic like this would force at least one item
                          //   var parentReview = formProxy.parentCurrentResource;
                          //   return parentReview.products && parentReview.products.length > 1;
                              return true
                        },
                        sortable: true,
                        sortableName: "linksOrder",
                        resourceType: ResourceApi.Types.DropdownButtonLink,
                        toggleSortLabelKey: "editbreak.steps.grocery.resultLink.reorder_toggle",
                        props: {
                          //headerKey: 'editbreak.steps.grocery.resultLink.section_header',
                          getCustomSectionHeader: (item, sectionIndex) => {
                            return item.label ? item.label : `Link - ${ (sectionIndex + 1) }`
                            // return product.dropdownTitle
                            // && product.dropdownTitle.trim() !== "" ? "Product " + (sectionIndex + 1) + ": " + product.dropdownTitle : null;
                          }
                        },
                    
              
                        footerContent: createButtonSectionFactory(ResourceApi.Types.DropdownButtonLink),
              
                        fields: [
                          {
                            type: "contenteditable",
                            name: "label",
                            required: false,
                            props: {
                              labelKey: "Label",
                            },
                          },
                          {
                            type: "text",
                            name: "url",
                            required: false,
                            props: {
                              labelKey: "Url",
                            },
                          },
              
                        ],
                      },                
              ],
            },        
          ]
        },        
      ]
    }, // end personality results
    {
      name: 'questions',
      subSection: true,
      resource: true,
      collection: true,
      sectionWrapper: IndexedSubSectionWrapper,
      deletable: true,
      canDelete: (formProxy) => {
        var parent = formProxy.parentCurrentResource;
        return parent.questions && parent.questions.length > 1;
      },

      sortable: true,
      sortableName: "personalityQuizQuestionsOrder",
      toggleSortLabelKey: 'editbreak.steps.personality_quiz.question.reorder_toggle',
      resourceType: ResourceApi.Types.PersonalityQuizQuestion,

      props: {
        headerKey: 'editbreak.steps.personality_quiz.question.header',
        getCustomSectionHeader: (question, sectionIndex) => {
          return question.text
          && question.text.trim() !== "" ? "Question " + (sectionIndex + 1) + ": " + question.text : null;
        }
      },

      footerContent: createButtonSectionFactory(ResourceApi.Types.PersonalityQuizQuestion),

      fields: [
        {
          type: 'radio',
          name: 'type',
          required: true,
          props: {
            labelKey: 'editbreak.steps.personality_quiz.question.type',
            helpContent: <PersonalityQuizQuestionTypeToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
              id={'editbreak.steps.personality_quiz.question.type'}/></IntlProvider>,
            options: [
              {
                value: "TEXT",
                textKey: 'editbreak.steps.personality_quiz.question.type.text'
              },
              {
                value: "IMAGE",
                textKey: 'editbreak.steps.personality_quiz.question.type.image'
              }
            ]
          }
        },
        {
          type: 'contenteditable',
          name: 'text',
          required: true,
          props: {
            labelKey: 'editbreak.steps.personality_quiz.question.text',
            helpContent: <PersonalityQuizQuestionToolTip/>,
            helpHeader: 'editbreak.steps.personality_quiz.question.text'
          }
        },
        {
          conditionalSection: true,
          name: "useDefaultImage",
          required: true,
          props: {
              labelKey: 'editbreak.steps.poll.question.use_default_image'
          },

          fields: [
            {
              type: 'dropdown',
              name: 'defaultImageId',
              required: true,
              props: {
                labelKey: 'editbreak.steps.poll.question.default_image',
                options: [
                  {
                    text: '',
                    value: ''
                  },
                  {
                    text: 'Purple Rainbow Gradient',
                    value: '9812ff0a-22af-427d-9748-3fdf7913affc',
                    imageId: '9812ff0a-22af-427d-9748-3fdf7913affc'
                  },
                  {
                    text: 'Purple Shooting Star',
                    value: '304ad25b-6e1d-48d6-807f-17e695730bd2',
                    imageId: '304ad25b-6e1d-48d6-807f-17e695730bd2'
                  },
                  {
                    text: 'Purple Tie Dye',
                    value: 'ffc1637f-5073-4620-ab23-db03182712dd',
                    imageId: 'ffc1637f-5073-4620-ab23-db03182712dd'
                  },
                  {
                    text: 'Purple Sound Waves',
                    value: '79d4611a-d20f-4d5c-a798-f5df31ea2e7e',
                    imageId: '79d4611a-d20f-4d5c-a798-f5df31ea2e7e'
                  },
                  {
                    text: 'Purple Milky Way',
                    value: '21b1ff99-a40a-4a78-82aa-130d5d8f2b4b',
                    imageId: '21b1ff99-a40a-4a78-82aa-130d5d8f2b4b'
                  },
                  {
                    text: 'Black Gradient',
                    value: '9f35e19b-b5ee-4d3e-bdc2-c8ce269d886c',
                    imageId: '9f35e19b-b5ee-4d3e-bdc2-c8ce269d886c'
                  },
                  {
                    text: 'Plum Tapestry',
                    value: '425913d3-d34a-48d5-be99-294d250e6805',
                    imageId: '425913d3-d34a-48d5-be99-294d250e6805'
                  },
                  {
                    text: 'Purple Tapestry',
                    value: '85568cb5-94e0-485a-8e4b-c4b86d54bc88',
                    imageId: '85568cb5-94e0-485a-8e4b-c4b86d54bc88'
                  },
                  {
                    text: 'Purple Wood Panes',
                    value: '8afdf75d-c003-4f1b-a019-698422445412',
                    imageId: '8afdf75d-c003-4f1b-a019-698422445412'
                  }
                ]
              }
            }
          ]
        },
        {
          type: 'image',
          name: 'imageId',
          idFor: 'image',
          required: false,
          showField: (proxy) =>  (!proxy.currentResource.useDefaultImage),
          props: {
            labelKey: 'editbreak.steps.personality_quiz.question.image',
            imageType: 'personalityQuestion',
            helpContent: <PersonalityQuizQuestionImageToolTip/>,
            helpHeader: 'editbreak.steps.personality_quiz.question.image',
          }
        },

        {
          type: 'yesnoradio',
          name: 'showOverlay',
          required: true,
          props: {
            labelKey: 'editbreak.steps.personality_quiz.question.show_overlay',
            helpContent: <PersonalityQuizQuestionShowOverlayToolTip/>,
            helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
              id={'editbreak.steps.personality_quiz.question.show_overlay'}/></IntlProvider>
          }
        },

        {
            type: 'keyValuePairs',
            name: 'keyValuePairs',
            required: false,
            showField: (proxy) => {
                console.log(proxy.currentResource)
                // return true
                return proxy.currentResource.displayOrder > 1
            },
            props: {
                label: 'Skip Question',
                separator: ' > '
            }
        },

        {
          name: 'answers',
          subSection: true,
          resource: true,
          collection: true,
          sectionWrapper: IndexedSubSectionWrapper,
          deletable: true,
          canDelete: (formProxy) => {
            var parentQuestion = formProxy.parentCurrentResource;
            return parentQuestion.answers && parentQuestion.answers.length > 2;
          },

          sortable: true,
          sortableName: "personalityQuizAnswersOrder",
          toggleSortLabelKey: 'editbreak.steps.personality_quiz.answer.reorder_toggle',
          resourceType: ResourceApi.Types.PersonalityQuizAnswer,

          props: {
            headerKey: 'editbreak.steps.personality_quiz.answer.header',
            getCustomSectionHeader: (answer, sectionIndex) => {
              return answer.text
              && answer.text.trim() !== "" ? "Answer " + (sectionIndex + 1) + ": " + answer.text : null;
            }
          },

          footerContent: createButtonSectionFactory(ResourceApi.Types.PersonalityQuizAnswer),

          fields: [
            {
              type: 'radio',
              name: 'type',
              required: true,
              props: {
                labelKey: 'editbreak.steps.personality_quiz.answer.type',
                helpContent: <PersonalityQuizAnswerTypeToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
                  id={'editbreak.steps.personality_quiz.answer.type'}/></IntlProvider>,
                options: [
                  {
                    value: "TEXT",
                    textKey: 'editbreak.steps.personality_quiz.answer.type.text'
                  },
                  {
                    value: "IMAGE",
                    textKey: 'editbreak.steps.personality_quiz.answer.type.image'
                  }
                ]
              }
            },
            {
              type: "yesnoradio",
              name: "hideText",
              showField: (proxy) => (proxy.currentResource.type === 'IMAGE'),
              props: {
                labelKey: 'editbreak.steps.personality_quiz.answer.hideText',
              }
            },
            {
              type: 'contenteditable',
              name: 'text',
              required: true,
              showField: (proxy) => (proxy.currentResource.type === 'TEXT')
                || (proxy.currentResource.type === 'IMAGE' && proxy.currentResource.hideText === false),
              props: {
                labelKey: 'editbreak.steps.personality_quiz.answer.text',
                helpContent: <PersonalityQuizAnswerToolTip/>,
                helpHeader: 'editbreak.steps.personality_quiz.answer.text'
              }
            },
            {
              type: 'image',
              name: 'imageId',
              idFor: 'image',
              required: true,
              showField: (proxy) => (proxy.currentResource.type === 'IMAGE'),
              props: {
                labelKey: 'editbreak.steps.personality_quiz.answer.image',
                imageType: 'personalityAnswer',
                helpContent: <PersonalityQuizAnswerImageToolTip/>,
                helpHeader: 'editbreak.steps.personality_quiz.answer.image'
              }
            },
            {
              type: 'answerResultDropdown',
              name: 'resultId',
              required: true,
              showField: proxy => {
                const masterSteps = proxy.currentBaseResource.steps;
                const pqStep = masterSteps.find(step => step.type === 'PERSONALITY_QUIZ');
                return pqStep.personalityQuiz.resultDisplay !== 'DECISION_TREE';
              },
              props: {
                labelKey: 'editbreak.steps.personality_quiz.answer.connected_result',
                helpContent: <PersonalityQuizConnectedResultToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
                  id={'editbreak.steps.personality_quiz.answer.connected_result'}/></IntlProvider>,
              }
            },
            {
              conditionalSection: true,
              name: "editButtonColors",
              required: true,
              showField: (proxy) => (proxy.currentResource.type === 'TEXT' && proxy.currentBaseResource.sponsoredType === 'sponsored'),
              props: {
                labelKey: 'editbreak.steps.personality_quiz.answer.edit_button_colors',
                helpContent: <PersonalityQuizAnswerEditButtonColorsToolTip/>,
                helpHeader: <IntlProvider locale="en" messages={enUSmessage}><FormattedMessage
                  id={'editbreak.steps.personality_quiz.answer.edit_button_colors'}/></IntlProvider>,
              },

              fields: [
                {
                  type: 'color',
                  name: 'bgColor',
                  required: true,
                  linkedField: (proxy) => ["missionColor1"],
                  props: {
                    labelKey: 'editbreak.steps.personality_quiz.answer.bg_color',
                    helpContent: <PersonalityQuizAnswerButtonBackgroundColorToolTip/>,
                    helpHeader: 'editbreak.steps.personality_quiz.answer.bg_color'
                  }
                },
                {
                  type: 'color',
                  name: 'textColor',
                  required: true,
                  linkedField: (proxy) => ["missionColor6"],
                  props: {
                    labelKey: 'editbreak.steps.personality_quiz.answer.text_color'
                  }
                }
              ]
            },
            {
                type: 'keyValuePairs',
                name: 'keyValuePairs',
                required: false,
                props: {
                    label: 'Answer Attributes (key value pairs)',
                }
            },
          ]
        } // end personality answers
      ]
    }, // end personality questions
    {
      name: 'decisionTree',
      showSection: (proxy) => {
        return proxy.parentCurrentResource.resultDisplay === 'DECISION_TREE'}
        ,
      resource: false,
      subSection: true,
      sortable: false,
      deletable: false,
      sectionWrapper: IndexedSubSectionWrapper,
      props: {
        headerKey: 'editbreak.steps.personality_quiz.decision_tree.accordion_heading'
      },
      fields: [{
        type: 'decisionTree',
        props: {

        }
      }]
    }
  ]
}



// WEBPACK FOOTER //
// ./public/components/EditContent/configs/breaks/steps/personality-quiz.js